module.exports = __webpack_public_path__ + "static/media/arrow-green.5d12e479.svg";